module.exports = __webpack_public_path__ + "static/media/hd-badge.dd0d32d6.svg";